export const formatUsd = (value: number) =>
  `$${new Intl.NumberFormat(document.documentElement.lang || "es-EC", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)}`;

export const formatPlainAmount = (value: number) =>
  new Intl.NumberFormat(document.documentElement.lang || "es-EC", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
